import { List, Tag, Typography, Button, Empty, Space } from 'antd';
import { useNotificationStore } from '@store/notificationStore';
import { fromNow } from '@/utils';
import { notificationService } from '@services/notificationService';

const colorMap = { info: 'blue', success: 'green', warning: 'orange', error: 'red' } as const;

export function NotificationCenter() {
  const items = useNotificationStore((s) => s.items);
  const markRead = useNotificationStore((s) => s.markRead);
  const markAllRead = useNotificationStore((s) => s.markAllRead);

  const handleMarkAll = async () => {
    await notificationService.markAllRead().catch(() => undefined);
    markAllRead();
  };

  return (
    <div style={{ width: 360, maxHeight: 480, overflow: 'auto' }}>
      <Space style={{ justifyContent: 'space-between', width: '100%', marginBottom: 8 }}>
        <Typography.Text strong>Notifications</Typography.Text>
        <Button type="link" size="small" onClick={handleMarkAll}>
          Mark all read
        </Button>
      </Space>
      {items.length === 0 ? (
        <Empty description="No notifications" />
      ) : (
        <List
          size="small"
          dataSource={items}
          renderItem={(n) => (
            <List.Item
              actions={[
                !n.read && (
                  <Button
                    key="r"
                    type="link"
                    size="small"
                    onClick={async () => {
                      await notificationService.markRead(n.id).catch(() => undefined);
                      markRead(n.id);
                    }}
                  >
                    Mark read
                  </Button>
                ),
              ]}
            >
              <List.Item.Meta
                title={
                  <>
                    <Tag color={colorMap[n.level]}>{n.level}</Tag>
                    <Typography.Text strong={!n.read}>{n.title}</Typography.Text>
                  </>
                }
                description={
                  <>
                    <div>{n.message}</div>
                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                      {fromNow(n.createdAt)}
                    </Typography.Text>
                  </>
                }
              />
            </List.Item>
          )}
        />
      )}
    </div>
  );
}
